import { render, staticRenderFns } from "./editRank.vue?vue&type=template&id=92062e5a&scoped=true&"
import script from "./editRank.vue?vue&type=script&lang=js&"
export * from "./editRank.vue?vue&type=script&lang=js&"
import style0 from "./editRank.vue?vue&type=style&index=0&id=92062e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92062e5a",
  null
  
)

export default component.exports